import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import Icon from "../components/ui/Icon";
import Avatar from "../components/ui/Avatar";
import usePageTheme from "../utils/usePageTheme";

const CONTACTS = [
    {name: "Gustaf", email: "gustaffrederiksen@gmail.com"},
    {name: "Henning", email: "henningtaufrederiksen@gmail.com"}
];

const ContactRow = ({name, email}) => {
    const [copied, setCopied] = useState(false);

    const copy = () => {
        const done = () => {
            setCopied(true);
            setTimeout(() => setCopied(false), 1800);
        };
        if (navigator.clipboard?.writeText) {
            navigator.clipboard.writeText(email).then(done).catch(() => {});
        }
    };

    return (
        <div className="contact-row">
            <Avatar name={name} size={40}/>
            <div className="contact-row__text">
                <strong>{name}</strong>
                <a href={`mailto:${email}`}>{email}</a>
            </div>
            <button type="button" className="btn btn-sm" onClick={copy} aria-label={`Copy ${email}`}>
                <Icon name={copied ? "check" : "copy"} size={16}/>
                <span className="contact-row__copy-label">{copied ? "Copied" : "Copy"}</span>
            </button>
        </div>
    );
};

// A small "talk to us" page - Chess Corner is made by two people, and we want to hear what players think
const Feedback = () => {
    usePageTheme("park");
    const navigate = useNavigate();

    return (
        <div className="page page--narrow">
            <div className="page-header">
                <div>
                    <div className="eyebrow">Feedback</div>
                    <h1>Tell us what you think</h1>
                </div>
            </div>
            <div className="card">
                <div className="card-body stack">
                    <p className="feedback-lead">
                        Chess Corner is a two-person project. Because it is so small, you can always write to us
                        with feedback, wishes for improvements or ideas for new things on the site. We read everything.
                    </p>
                    <div className="stack stack--sm">
                        {CONTACTS.map((contact) => <ContactRow key={contact.email} {...contact}/>)}
                    </div>
                    <p className="small muted" style={{margin: 0}}>
                        Found a bug? Tell us what you were doing when it happened and which browser you use. It helps a lot.
                    </p>
                </div>
            </div>
            <div className="row" style={{marginTop: "1rem", gap: "0.5rem"}}>
                <button className="btn" onClick={() => navigate("/")}><Icon name="board"/> Back to the front page</button>
                <button className="btn btn-ghost" onClick={() => navigate("/credits")}>Credits</button>
            </div>
        </div>
    );
};

export default Feedback;
